import React, { Component } from 'react';
import queryString from 'query-string'
import Cookies  from 'universal-cookie';
import  axios  from 'axios';
import { VkGroupBlock } from './VkGroupBlock';
import {Loader} from './Loader.js';


export class VkGroupCallback extends React.Component {


    //access_token = '3ea5fb639a426cf9d3363ee11e487ed97015468f1e5d07632a135bb323aea75aface6fd05f3a53f0aa4b2';
    
   

    constructor(props) {
        super(props);
        
        
        const value=queryString.parse(window.location.search);
        const code = value.code;
        
        this.code = code
        console.log(this.code)
        const cookies = new Cookies();
        console.log( cookies.get('vk_group_id') )
        
    }

    componentDidMount() {
        //http://localhost:8000/VkGroupGetTokenByCode?code=4822f2b72f15b87798&group_id=188523976
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/VkGroupGetTokenByCode?code='+this.code+'&group_id='+cookies.get('vk_group_id'), {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    //projects = res.data.projects
                   console.log(res.data)
                    
                    if (res.data.status == 'ok') {
                        window.location.href = '/vkcreatewidget'
                    }
                    
                   
                    

                })
                .catch(err => {
                  cookies.set('errorBack', true, {path: '/'})
                  window.history.back();
                    

                })
    }
    


    render() {
        return (
            <div className='createPage'>
               <Loader loader={true} />
                <h1> Создать виджет</h1>
                <svg
                className='h1_line'
      xmlns="http://www.w3.org/2000/svg"
      width="117"
      height="1"
      fill="none"
      viewBox="0 0 117 1"
    >
      <path stroke="url(#paint0_linear_35_988)" d="M0 0.5L117 0.5"></path>
      <defs>
        <linearGradient
          id="paint0_linear_35_988"
          x1="-0.325"
          x2="117.101"
          y1="1"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0767F4"></stop>
          <stop offset="1" stopColor="#2AC3D1"></stop>
        </linearGradient>
      </defs>
    </svg>
            
            
        </div>         
        )
    }
}